import React from 'react'
import './header.css'
import CTA from './CTA'
import HeaderSocials from './HeaderSocials'

const Header = () => {
  return (
    <header id='header'>

      

      
      <div className="header__container mask">

        <div className="header__content">
          <h1>FOOD</h1>
          <h3>Confitería & Pastelería</h3>

          <CTA/>
          <HeaderSocials/>
        </div>
        
       
      </div>
    </header>
  )
}

export default Header